/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../../components/header/Header";
import OnChangeInputField from "../../components/onChangeInputField/OnChangeInputField";
import Button from "../../components/button/Button";
import styles from "./ManageUsersPage.module.css";
import { apiUrl } from "../../constants";
import InsertUser from "../../components/insertUser/InsertUser";
import DisplayUser from "../../components/displayUser/DisplayUser";
import DeleteUser from "../../components/deleteUser/DeleteUser";

const ManagerUsersPage = () => {
  const [errorMessage, setErrorMessage] = useState(true);
  const [displayErrorMessage, toggleDisplayErrorMessage] = useState(false);
  const [result, setResult] = useState([]);
  const [displayAllUsers, toggleDisplayAllUsers] = useState(true);
  const [displayNewUserForm, toggleDisplayNewUserForm] = useState(false);
  const [id, setId] = useState();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user");
  const [errorFirstName, toggleErrorFirstName] = useState(false);
  const [errorLastName, toggleErrorLastName] = useState(false);
  const [errorEmail, toggleErrorEmail] = useState(false);
  const [dataReady, toggleDataReady] = useState(false);
  const [submitted, toggleSubmitted] = useState(false);
  const [getUser, setGetUser] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [displayDeleteUserForm, toggleDisplayDeleteUserForm] = useState(false);
  const [sortedResult, setSortedResult] = useState([]);

  const showNavigation = true;

  // When the page is loaded we clear the state
  useEffect(() => {
    clearState();
  }, []);

  // We clear the state and request all users
  function clearState() {
    setGetUser(false);
    toggleDisplayAllUsers(true);
    toggleErrorFirstName(false);
    toggleErrorLastName(false);
    toggleErrorEmail(false);
    setErrorMessage(true);
    toggleDataReady(false);
    getAllUsers();
    setId();
    toggleDisplayDeleteUserForm(false);
  }

  // Here we save all the user data in result so we can display it on the page
  async function getAllUsers() {
    const jwtToken = localStorage.getItem("token");
    toggleLoading(true);
    try {
      const { data } = await axios.get(`${apiUrl}/api/auth/allusers`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      setResult(data);
    } catch (e) {
      console.error(e);
    }
    toggleLoading(false);
  }

  // Here we sort the result by lastName.
  useEffect(() => {
    const sortedResult = result.sort((a, b) =>
      a.firstName.localeCompare(b.firstName)
    );
    setSortedResult(sortedResult);
  }, [result]);

  // Here we set the userId so we can use it to fill in the form when we remove all the users from the page.
  function displayUpdateFormWithUserData(userId) {
    setId(userId);
    toggleDisplayAllUsers(false);
  }

  // Update the state so we can get the user data.
  useEffect(() => {
    function readyToGetUser() {
      setGetUser(true);
    }
    if (id) {
      readyToGetUser();
    }
  }, [id]);

  // Save the user data into the state and toggleDataReady(true) so the form will be filled in with the user data from the database.
  useEffect(() => {
    async function getUserData() {
      const jwtToken = localStorage.getItem("token");
      toggleLoading(true);
      try {
        const { data } = await axios.get(`${apiUrl}/api/auth/userdata/${id}`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setFirstName(data.firstName);
        setLastName(data.lastName);
        setEmail(data.email);
        setRole(data.role);
        toggleDataReady(true);
      } catch (e) {
        console.error(e);
      }
      toggleLoading(false);
    }
    if (getUser) {
      getUserData();
    }
  }, [getUser]);

  // When the user changes the input fields we update the state.
  const handleChange = (e, target) => {
    let input = e.target.value;
    if (target === "firstName") {
      if (input === "") {
        setFirstName(input);
        toggleErrorFirstName(true);
      } else {
        toggleErrorFirstName(false);
        setFirstName(input);
      }
    }
    if (target === "lastName") {
      if (input === "") {
        toggleErrorLastName(true);
        setLastName(input);
      } else {
        toggleErrorLastName(false);
        setLastName(input);
      }
    }
    if (target === "email") {
      if (input === "") {
        toggleErrorEmail(true);
        setEmail(input);
      } else {
        toggleErrorEmail(false);
        setEmail(input);
      }
    }
  };

  // On submitting the form we first check if there are errors.
  function updateData(e) {
    e.preventDefault();
    checkErrors();
  }

  // If there are no errors we can set the displayName state.
  function checkErrors() {
    if (role) {
      if (!errorFirstName && !errorLastName && !errorEmail) {
        setDisplayName(firstName.toLowerCase() + lastName.toLowerCase());
        setErrorMessage(false);
      }
    }
  }

  // update the state again to be ready to send the data.
  useEffect(() => {
    function readyToUpdate() {
      update();
      toggleSubmitted(true);
    }

    if (!errorMessage) {
      readyToUpdate();
    }
  }, [errorMessage]);

  // Here we send the data to the backend.
  async function update() {
    const jwtToken = localStorage.getItem("token");
    toggleLoading(true);
    toggleDisplayErrorMessage(false);
    try {
      await axios.put(
        `${apiUrl}/api/auth/user/${id}`,

        {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          displayName: displayName.trim(),
          email: email.trim(),
          role: role.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      clearState();
    } catch (e) {
      console.error(e);
      toggleDisplayErrorMessage(true);
    }
    toggleLoading(false);
  }

  // Here we set the original list again with all the users and show the updated version of the changed user.
  useEffect(() => {
    function readyToDisplayAllUsersAgain() {
      getAllUsers();
      toggleDisplayAllUsers(true);
      toggleDisplayNewUserForm(false);
      toggleDataReady(false);
    }

    if (submitted) {
      readyToDisplayAllUsersAgain();
    }
  }, [submitted]);

  // This is the menu. Here can we display all the users.
  function allUsers() {
    toggleDisplayAllUsers(true);
    toggleDisplayNewUserForm(false);
    toggleDataReady(false);
    setId();
    getAllUsers();
    clearState();
    toggleDisplayDeleteUserForm(false);
  }

  // This is the menu. Here can we display the form to insert a new user.
  function newUser() {
    toggleDisplayAllUsers(false);
    toggleDisplayNewUserForm(true);
    toggleDataReady(false);
    toggleDisplayDeleteUserForm(false);
  }

  function deleteUser() {
    toggleDisplayDeleteUserForm(true);
    toggleDisplayAllUsers(false);
    toggleDisplayNewUserForm(false);
    toggleDataReady(false);
  }

  return (
    <div>
      <Header showNavigation={showNavigation} />

      <div className={styles["manage-user-page-container"]}>
        <div className={styles["menu-form-wrapper"]}>
          <div className={styles["menu-container"]}>
            <h3 onClick={allUsers}>Menu</h3>
            <button className={styles["user-menu-button"]} onClick={allUsers}>
              Show all users
            </button>
            <button className={styles["user-menu-button"]} onClick={newUser}>
              Add new user
            </button>
            <button className={styles["user-menu-button"]} onClick={deleteUser}>
              Delete user
            </button>
          </div>

          <div className={styles["line-devider"]}></div>
          {displayAllUsers && (
            <div className={styles["users-container"]}>
              <h3>All users</h3>
              <p>Please click on the user to update the data.</p>
              {sortedResult?.map((user) => {
                const { _id, firstName, lastName, email, role } = user;

                return (
                  <div className={styles["user-wrapper"]} key={_id}>
                    <DisplayUser
                      handleClick={() => displayUpdateFormWithUserData(_id)}
                      firstName={firstName}
                      lastName={lastName}
                      email={email}
                      role={role}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {displayNewUserForm && <InsertUser />}
          {displayDeleteUserForm && <DeleteUser />}

          {dataReady && (
            <div className={styles["update-user-form-container"]}>
              <div className={styles["update-user-form"]}>
                <form onSubmit={updateData}>
                  <h4>Update user</h4>
                  <section>
                    <OnChangeInputField
                      label="First name"
                      name="firstName"
                      type="text"
                      id="first-name-field"
                      onChange={(e) => handleChange(e, "firstName")}
                      value={firstName}
                    />
                    <div className={styles["update-user-error-wrapper"]}>
                      {errorFirstName && (
                        <p className={styles.error}>First name is required</p>
                      )}
                    </div>
                  </section>

                  <section>
                    <OnChangeInputField
                      label="Last name"
                      name="lastName"
                      type="text"
                      id="last-name-field"
                      onChange={(e) => handleChange(e, "lastName")}
                      value={lastName}
                    />
                    <div className={styles["update-user-error-wrapper"]}>
                      {errorLastName && (
                        <p className={styles.error}>Last name is required</p>
                      )}
                    </div>
                  </section>

                  <section>
                    <OnChangeInputField
                      label="Email"
                      name="email"
                      type="email"
                      id="email-sign-in-field"
                      pattern={/[0-9a-zA-Z]{6,}/}
                      onChange={(e) => handleChange(e, "email")}
                      value={email}
                    />
                    <div className={styles["update-user-error-wrapper"]}>
                      {errorEmail && (
                        <p className={styles.error}>Email is required</p>
                      )}
                    </div>
                  </section>

                  <section className="select-wrapper-role">
                    <div className="label-wrapper">
                      <label>Role </label>
                    </div>
                    <div>
                      <select onChange={(e) => setRole(e.target.value)}>
                        <option value={role}>{role}</option>
                        {role === "admin" ? (
                          <option value="user">user</option>
                        ) : (
                          <option value="admin">admin</option>
                        )}
                      </select>
                    </div>
                  </section>
                  <section className={styles["update-user-button-wrapper"]}>
                    <Button type="submit">Update</Button>
                  </section>
                </form>

                <div className={styles["update-user-error-wrapper"]}>
                  {displayErrorMessage && (
                    <span className={styles.error}>
                      Something went wrong with sending the data, please try
                      again later.
                    </span>
                  )}
                </div>
                <div className={styles["loading-wrapper"]}>
                  {loading && <p className={styles.loading}>Loading...</p>}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManagerUsersPage;
